import { Button, Divider } from "@blueprintjs/core"
import { HasId, ID } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILandingSection, SECTION_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import updateHistory from "./utils/updateHistory"
import ProportionScalar from "src/modules/pe-landing-module/widgets/composite/ProportionScalar"
import updateSection from "./utils/updateSection"

/* Protopia Ecosystem component */
export interface IColumnWidgetProps {
   sectionId: ID
}
const ColumnWidget = (props: IColumnWidgetProps): JSX.Element => {
    const currentLanding    = useLandingStore((state: ILandingStore) => state.currentLanding)
    const section           = currentLanding.sections.find( (section: HasId) => section.id === props.sectionId ) 
    const composition       = useComposition(section)
    const onCount = (counts: number) => {
        const prevData          = JSON.parse( JSON.stringify( section ) )
        const newSection: any   = { 
            ...section, 
            composition: {
                ...composition,
                columns: counts,
                proportia: Array(section.data.length || counts).fill(0)
                    .map(pr => 100 / counts)
            }
        } 
        const historyStep: IHistoryStep = {
            data:  newSection,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title : "Change section's columns",
        }
        updateSection(newSection, historyStep)  
    }
    const onAdd = () => {
        if(composition.columns < 12) {
            onCount( composition.columns + 1)
        }
    }
    const onRemove = () => {
        if(composition.columns > 1 ) {
            onCount( composition.columns - 1)
        }
    }
    const onProportiaChange = (value: number[], field: string, dop: any="") => {
        
        console.log( value, field )
        const counts            = value.length
        const prevData          = JSON.parse( JSON.stringify( section ) )
        const newSection: any   = { 
            ...section, 
            composition: {
                ...composition,
                columns: counts,
                proportia: value
            }
        } 
        const historyStep: IHistoryStep = {
            data:  newSection,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title : "Change section's proportia",
        }
        updateSection(newSection, historyStep) 
    }
    return [ SECTION_DESIGN_TYPE.CAROUSEL, SECTION_DESIGN_TYPE.COLUMN, ].includes( section.designType )
        ?
        <>
            <div className="p-2 "> 
                <div className="d-flex align-items-center w-100">
                    { __( "Columns" ) }: 
                    <span className="title ml-2 text-wrap mr-auto">{ composition.columns }</span>
                    <Button variant="minimal" size="small" icon="chevron-up" disabled={ composition.columns > 11 } onClick={onAdd} /> 
                    <Button variant="minimal" size="small" icon="chevron-down"  disabled={ composition.columns < 2 } onClick={onRemove}/>
                </div> 
            </div> 
            <div className="pl-4 py-2">
                <ProportionScalar
                    editable
                    dataSection="Section"
                    dataName="proportia"
                    type={ "" }
                    columns={composition.columns}
                    value={ composition.proportia }
                    onChange={onProportiaChange}
                />
            </div> 
            <Divider />
        </>
        :
        <></>
}
export default ColumnWidget